import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {VmiAlertasService} from '../../../services/administracion/vmi-alertas.service';
import {VmiUsuariosService} from '../../../services/administracion/vmi-usuarios.service';
import {UsuarioModel} from '../../../models/vmi-usuarioModel';
import {VmiColorPorcentajeService} from '../../../services/administracion/vmi-color-porcentaje.service';
import {ColorModel} from '../../../models/vmi-colorModel';
import {ColorAlertaModel} from '../../../models/vmi-color-alertaModel';

@Component({
  selector: 'app-vmi-frm-mantenedor-alertas',
  templateUrl: './vmi-frm-mantenedor-alertas.component.html',
  styleUrls: ['./vmi-frm-mantenedor-alertas.component.css']
})
export class VmiFrmMantenedorAlertasComponent implements OnInit {

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};
  cmbUsuarios: UsuarioModel[];
  cmbColores: ColorModel[];


  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _alertas: VmiAlertasService,
    private _usuario: VmiUsuariosService,
    private _color: VmiColorPorcentajeService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.alertas;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      colAlertaId: [''],
      color: ['', [Validators.required]],
      usuarioAlerta: ['', [Validators.required]],
      colEstado: ['']
    });

    this.gridComponent();
    this.getAll();
    this.getAllUsuarios();
    this.getAllColorPorcentaje();
  }

  //*SERVICIOS
  getAll() {
    this._alertas.getAll().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  getAllUsuarios() {
    this._usuario.getAll().subscribe((res: UsuarioModel[]) => {
      this.cmbUsuarios = res.map(usuario => {
        usuario['descripcion'] = `${usuario.usuNick} - ${usuario.usuNombre}`;
        return usuario;
      });
    }, (err) => {
      this.cmbUsuarios = [];
    });
  }

  getAllColorPorcentaje() {
    this._color.getAll().subscribe((res: ColorModel[]) => {
      this.cmbColores = res.map(color => {
        color['descripcion'] = `${color.colorReferencia} - ${color.colorDescripcion}`;
        return color;
      });
    }, (res) => {
      this.cmbColores = [];
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'No',
        field: 'colAlertaId',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'USUARIO',
        field: 'usuarioAlerta.usuNombre',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'COLOR',
        field: 'color.colorDescripcion',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'REFERENCIA',
        field: 'color.colorReferencia',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editar({rowData}) {
    const color: ColorAlertaModel = rowData;
    const obj = {
      colAlertaId: color.colAlertaId,
      color: color.color.colorId,
      usuarioAlerta: color.usuarioAlerta.usuId,
      colEstado: color.colEstado
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    const color: ColorAlertaModel = rowData;
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._alertas.delete(color.colAlertaId),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.regresar();
    }
  }

  guardar() {
    const idColor = this.formulario.get('color').value;
    const idUsuarioAlerta = this.formulario.get('usuarioAlerta').value;
    const color: ColorAlertaModel = Object.assign(this.formulario.value);
    color.colEstado = 1;
    color.color = this.cmbColores.find(color => color.colorId === idColor);
    color.usuarioAlerta = this.cmbUsuarios.find(usuario => usuario.usuId === idUsuarioAlerta);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._alertas.create(color),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    const idColor = this.formulario.get('color').value;
    const idUsuarioAlerta = this.formulario.get('usuarioAlerta').value;
    const color: ColorAlertaModel = Object.assign(this.formulario.value);
    color.color = this.cmbColores.find(color => color.colorId === idColor);
    color.usuarioAlerta = this.cmbUsuarios.find(usuario => usuario.usuId === idUsuarioAlerta);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._alertas.edit(color),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

}
